import React from 'react'
import { useForm } from 'react-hook-form'
import { Button, Box, Typography } from '@mui/material'
import { api } from 'services'
import { useSnackbar } from 'notistack'

export default function DeleteClinicalDataForm ({ id, closeModalFunction, exitFunction }) {
  const { enqueueSnackbar } = useSnackbar()
  const { handleSubmit } = useForm()

  // Form Submission Handling
  const onSubmit = (data) => {
    if (id) {
      api.clinicalData
        .delete(id)
        .then(function (response) {
          enqueueSnackbar('Clinical data has been deleted.', {
            variant: 'success',
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'center'
            }
          })
          exitFunction()
          closeModalFunction()
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
  return (
    <form id="delete_clinical_data_form" data-testid="delete-clinical-data-test" onSubmit={handleSubmit(onSubmit)}>
      <Box display="flex" flexDirection="row" justifyContent="flex-start">
        <Box flexGrow={1}>
          <Typography variant="subtitle1" color="error">
            {'Are you sure you want to delete this data?'}
          </Typography>
        </Box>
        <Box pr={2}>
          <Button type="submit" variant="contained" color="error" size="small">
            {'Delete Data'}
          </Button>
        </Box>
        <Button color="primary" variant='contained' size="small" onClick={closeModalFunction}>
          {'Cancel'}
        </Button>
      </Box>
    </form>
  )
}
